<nz-select
	nzAllowClear
	nzPlaceHolder="Select a status"
	[ngModel]="selectedUuid"
	(ngModelChange)="onSelectionChanged($event)"
>
	@for (ps of productStatuses(); track $index) {
		<nz-option [nzValue]="ps.uuid" [nzLabel]="ps.status" />
	}
</nz-select>
